import React from 'react';
import MobileDevIcon from '../svg/mobile.svg';

const IconMobileDev = () => (
  <img src={MobileDevIcon} alt="Mobile Development Icon" width={64} height={64} />
);

export default IconMobileDev;
